// Cashiers State

export default {
  cashiersList: [],
  cashierInfo: {}
}
